import { useState, useEffect } from 'react';
import { ISlidingDrawerProps } from './SlidingDrawer.interfaces';
import {
    DrawerWrapper,
    TabButton,
    DrawerContent,
} from './SlidingDrawer.styles';
import { Icon } from '../../base';

const SlidingDrawer = (props: ISlidingDrawerProps) => {
    const {
        placement,
        positionOffset,
        tabContent,
        children,
        isOpen: controlledIsOpen,
        onToggle,
        tabIcon,
    } = props;
    const [internalIsOpen, setInternalIsOpen] = useState(false);

    const isControlled = controlledIsOpen !== undefined;
    const isOpen = isControlled ? controlledIsOpen : internalIsOpen;

    const handleStateChange = (newIsOpen: boolean) => {
        if (onToggle) {
            onToggle(newIsOpen);
        }
        if (!isControlled) {
            setInternalIsOpen(newIsOpen);
        }
    };

    const handleToggle = () => handleStateChange(!isOpen);
    const handleClose = () => handleStateChange(false);

    useEffect(() => {
        if (isControlled) {
            setInternalIsOpen(controlledIsOpen);
        }
    }, [controlledIsOpen, isControlled]);

    return (
        <div onMouseLeave={handleClose}>
            <DrawerWrapper
                placement={placement}
                positionOffset={positionOffset}
            >
                <TabButton
                    onClick={handleToggle}
                    elevation={2}
                    style={{ visibility: isOpen ? 'hidden' : 'visible' }}
                    placement={placement}
                >
                    {tabIcon && <Icon name={tabIcon} />}
                    {tabContent}
                </TabButton>
            </DrawerWrapper>
            <DrawerContent placement={placement} isOpen={isOpen} elevation={4}>
                {children}
            </DrawerContent>
        </div>
    );
};

export default SlidingDrawer;
